module.exports = __webpack_public_path__ + "media/bacMusic.95dce774.mp3";